module.exports = __webpack_public_path__ + "static/media/type-hover-3.825af6fd.jpg";